import React from 'react';
import '../styles/DuplicateOverlay.css';

const DuplicateOverlay = ({ duplicates, onClose }) => {
  return (
    <div className="duplicate-overlay">
      <div className="duplicate-content">
        <h2>重複項目</h2>
        <ul>
          {duplicates.map((item, index) => (
            <li key={index}>
              {item.priority} の {item.cycle} に重複があります
            </li>
          ))}
        </ul>
        <button onClick={onClose}>閉じる</button>
      </div>
    </div>
  );
};

export default DuplicateOverlay;
